import { CountryCode, isDemo, isNordiskaGalleriet, isPilot } from '@glow/common'
import { tUnchecked } from '@glow/language'
import { List, Map } from 'immutable'
import once from 'lodash-es/once'
import { ImmutableMap } from '../types/immutableTypes'

interface ICountryProps {
  code: string
  name: string
}

export interface ICountry extends ImmutableMap<ICountryProps> {}

export const getSupportedCountries = () => {
  if (isDemo()) {
    return demoCountries()
  } else if (isPilot()) {
    return pilotCountries()
  } else if (isNordiskaGalleriet()) {
    return nordiskaGallerietCountries()
  } else {
    return bringCountries()
  }
}

export enum Country {
  NO = 'Norway',
  SE = 'Sweden',
  FI = 'Finland',
  DK = 'Denmark',
  BE = 'Belgium',
  FR = 'France',
  GB = 'United Kingdom',
  SI = 'Slovenia'
}

function country(cc: CountryCode) {
  return Map({ code: cc, name: tUnchecked('application.country.' + cc) })
}

// Built on first use, not on import: this module loads at startup, before i18next has the user's language
const countries = once(() =>
  List<ICountry>([
    country(CountryCode.AD),
    country(CountryCode.AT),
    country(CountryCode.BE),
    country(CountryCode.BA),
    country(CountryCode.BG),
    country(CountryCode.HR),
    country(CountryCode.CZ),
    country(CountryCode.DK),
    country(CountryCode.GB),
    country(CountryCode.EE),
    country(CountryCode.FO),
    country(CountryCode.FI),
    country(CountryCode.FR),
    country(CountryCode.DE),
    country(CountryCode.GI),
    country(CountryCode.GR),
    country(CountryCode.HU),
    country(CountryCode.IS),
    country(CountryCode.IE),
    country(CountryCode.IT),
    country(CountryCode.LV),
    country(CountryCode.LT),
    country(CountryCode.LU),
    country(CountryCode.MK),
    country(CountryCode.MT),
    country(CountryCode.MC),
    country(CountryCode.ME),
    country(CountryCode.NL),
    country(CountryCode.NO),
    country(CountryCode.PL),
    country(CountryCode.PT),
    country(CountryCode.RO),
    country(CountryCode.RU),
    country(CountryCode.SM),
    country(CountryCode.RS),
    country(CountryCode.SK),
    country(CountryCode.SI),
    country(CountryCode.ES),
    country(CountryCode.SE),
    country(CountryCode.CH),
    country(CountryCode.UA)
  ])
)

const bringCountries = once(() =>
  countries().filter((country) =>
    new Set([CountryCode.NO, CountryCode.FI, CountryCode.DK, CountryCode.SE, CountryCode.DE, CountryCode.EE]).has(
      country.get('code') as CountryCode
    )
  )
)

const demoCountries = countries

// Denmark
const pilotCountries = once(() =>
  countries().filter((country) => new Set([CountryCode.DK]).has(country.get('code') as CountryCode))
)

const nordiskaGallerietCountries = once(() =>
  countries().filter((country) => new Set([CountryCode.SE]).has(country.get('code') as CountryCode))
)

export const getCountryNameFromCountryCode = (countryCode: string | undefined | null): string | undefined =>
  getSupportedCountries()
    .find((country) => country.get('code').toLowerCase() === countryCode?.toLowerCase())
    ?.get('name')
